import url from 'url'
import { Ingredient } from '@/models/Ingredient'
import { Instruction } from '@/models/Instruction'

// const items = {
//   'Ingredient': Ingredient,
//   'Instruction': Instruction
// }
//
// const toInstance = (type, obj = {}) => {
//   const ItemClass = items[type]
//   return Object.keys(obj).reduce((result, key) => {
//     result[key] = new ItemClass(obj[key], key)
//     return result
//   }, {})
// }

class Recipe {
  constructor (props = {}, key) {
    this.key = key
    this.addedAt = props.addedAt
    this.collections = props.collections || {}
    this.cookTime = props.cookTime
    this.extractionState = props.extractionState
    this.givenUrl = props.givenUrl
    this.image = props.image || {}

    // Recipe instances store ingredients/instructions as an array, whereas
    //   our datastore is an object
    this.ingredients = Object.keys(props.ingredients || {}).map(key => {
      return new Ingredient(props.ingredients[key], key)
    }).sort((a, b) => {
      return a.priority - b.priority
    })
    this.instructions = Object.keys(props.instructions || {}).map(key => {
      return new Instruction(props.instructions[key], key)
    }).sort((a, b) => {
      return a.priority - b.priority
    })
    this.localImageUrl = props.localImageUrl
    this.name = props.name
    this.prepTime = props.prepTime
    this.sourceType = props.sourceType
    this.totalTime = props.totalTime
    this.url = props.url
    this.recipeYield = props.recipeYield || props.yield
    this.resolvedUrl = props.resolvedUrl
    // switch (typeof(props.notes)) {
    //   case 'object': this.notes = props.notes; break
    //   case 'string': this.notes = props.notes.split('\n'); break
    // }
    this.notes = props.notes && props.notes.split('\n')

    let serverImageUrl = (this.image.sourceUrl || this.image.servingUrl)
    if (serverImageUrl) serverImageUrl = serverImageUrl.replace(/^http:\/\//, 'https://')
    this._imageUrl = serverImageUrl || this.localImageUrl
    this.presentationUrl = this.url || this.resolvedUrl || this.givenUrl
  }

  consoleUrl ({ userId, projectId = process.env.FIREBASE_PROJECT_ID }) {
    const basePath = `https://console.firebase.google.com/project/${projectId}/database/data`
    return `${basePath}/users/${userId}/recipes/${this.key}`
  }

  get collectionKeys () {
    return Object.keys(this.collections)
  }

  get domain () {
    if (!this.presentationUrl) return

    let resolvedUrl = url.resolve('https://cookmark.io', this.presentationUrl)
    let parsedUrl = url.parse(resolvedUrl)
    if (!parsedUrl.hostname) return
    return parsedUrl.hostname.replace('www.', '')
  }

  inAnyCollection () {
    return this.collectionKeys.filter(key => key.startsWith('-')).length > 0
  }

  inCollection (collectionKey) {
    return !!this.collections[collectionKey]
  }

  get isBlank () {
    return this.ingredients.length === 0 && this.instructions.length === 0
  }

  get isProcessing () {
    return this.extractionState === 'added'
  }

  get metadata () {
    let metadata = {
      prepTime: this.prepTime,
      cookTime: this.cookTime,
      recipeYield: this.recipeYield
    }

    if (this.presentationUrl) {
      metadata['domain'] = this.domain
      metadata['url'] = this.presentationUrl
    }
    return metadata
  }

  get parentedTitle () {
    if (!this.title) return this.truncatedUrl

    return this.title.replace(/\s+([^\s]*)\s*$/, `\xA0$1`)
  }

  get pinned () {
    return this.inCollection('pinned')
  }

  get favorited () {
    return this.inCollection('favorites')
  }

  get notFound () {
    return this.sourceType !== 'manual' && this.isBlank && !this.isProcessing
  }

  get title () {
    return this.name
  }

  get text () {
    const structToString = (i, ii) => i.section
      ? `${ii > 0 ? '\n' : ''}${i.text}`
      : ` * ${i.text}`

    return `${this.parentedTitle}
${
  this.recipeYield ? `\nYield: ${this.recipeYield}` : ''
}${
  this.url ? `\nAdapted from: ${this.url}` : ''
}


INGREDIENTS:

${this.ingredients.map(structToString).join('\n')}


INSTRUCTIONS:

${this.instructions.map(structToString).join('\n')}
`
  }

  get truncatedUrl () {
    let url = this.presentationUrl
    if (!url) return
    return url.length > 42 ? url.substring(0, 42) + '...' : url
  }

  imageUrl (format) {
    if (!format) throw new Error('Image format required')
    if (!this._imageUrl) return undefined
    if (this.isLocalImage) return this._imageUrl
    const path = require('path')
    const fetchUrl = 'https://res.cloudinary.com'
    const fetchPath = '/cookmark/image/fetch'
    let transformations = '.'
    // w_300,h_300/https%3A%2F%2Fimages.food52.com%2FJVIpb7JSoL9R3nHsMwLBiELZpvE%3D%2F1200x1200%2F697c3390-705a-43a1-a589-97a7de669e31--2018-0523_beef-kimchi-burger_3x2_ty-mecham_004.jpg

    switch (format) {
      case 'full':
        transformations = 'w_1600,h_1600,c_limit'
        break
      case 'list':
        transformations = 'w_180,h_120,c_fill'
        break
      case 'placeholder':
        transformations = 'w_30'
        break
      case 'preview':
        transformations = 'w_600'
        break
      // default:
      //   return this.imageUrl
    }

    return url.resolve(fetchUrl, path.join(
      fetchPath,
      transformations,
      escape(this._imageUrl)
    ))
  }

  get isLocalImage () {
    return !!this._imageUrl.startsWith('blob')
  }

  get hasImage () {
    return !!this._imageUrl
  }

  ref (userId) {
    return `users/0/recipes/${this.key}`
  }
}

export { Recipe }



// WEBPACK FOOTER //
// ./src/models/Recipe.js